(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector(
          'input[name="locale_code"], input[name="country_code"]',
        ),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      }
      this.elements.button.addEventListener(
        'click',
        this.openSelector.bind(this),
      )
      this.elements.button.addEventListener(
        'focusout',
        this.closeSelector.bind(this),
      )
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

      this.querySelectorAll('a').forEach(item =>
        item.addEventListener('click', this.onItemClick.bind(this)),
      )
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false')
      this.elements.panel.setAttribute('hidden', true)
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return

      this.hidePanel()
      this.elements.button.focus()
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      const input = event.currentTarget.dataset.input
      const value = event.currentTarget.dataset.value

      if (input === 'country_code') {
        // Specific logic for country code
        const returnToInput = form.querySelector("input[name='return_to']")
        // Check if the 'country' parameter already exists
        if (returnToInput.value.match(/(\?|&)country=[^&]*/)) {
          // Replace the existing country parameter
          returnToInput.value = returnToInput.value.replace(
            /(\?|&)country=[^&]*/,
            '$1country=' + value,
          )
        } else {
          // Add the country parameter
          let existingParams = returnToInput.value.includes('?') ? '&' : '?'
          returnToInput.value += `${existingParams}country=${value}`
        }

        // Set the cookie for the country code
        document.cookie = `mdApp_countryCodeDomain=${value}; domain=${shopDomain}; path=/; max-age=${
          60 * 60 * 24 * 60
        };`
      }

      // Update the input value and submit the form
      this.elements.input.value = value
      if (form) form.submit()
    }

    openSelector() {
      this.elements.button.focus()
      this.elements.panel.toggleAttribute('hidden')
      this.elements.button.setAttribute(
        'aria-expanded',
        (
          this.elements.button.getAttribute('aria-expanded') === 'false'
        ).toString(),
      )
    }

    closeSelector(event) {
      const shouldClose =
        event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON'
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel()
      }
    }
  }

  customElements.define('localization-form', LocalizationForm)

  } catch(e) { console.error(e); }
})();
})();
